import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { BaseComponent, IconButtonComponent } from 'clicklease-ui-elements';

@Component({
    selector: 'rose-portal-back-button',
    standalone: true,
    imports: [
        IconButtonComponent
    ],
    templateUrl: 'back-button.component.html',
    styleUrl: 'back-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackButtonComponent extends BaseComponent {
    readonly #location = inject(Location);

    public override onClick(): void {
        this.#location.back();
    }
}